import { Injectable } from "@angular/core";
import { FormControlStatus, FormGroup } from "@angular/forms";
import { EAccountServiceCode } from "@common/models";
import { ResultService } from "@common/services";
import { BaseFpxFormHelper, BaseFpxComponentState, BaseFpxChangeHandler } from "src/app/common/utils/base-fpx.form.component";
import { IRequestChequeBookModel } from "../models/request-cheque-book.model";
import { RequestChequeBookService } from "./request-cheque-book.service";


export class RequestChequeBookState extends BaseFpxComponentState {
    disableMode: boolean;
}


@Injectable()
export class RequestChequeBookHelper extends BaseFpxFormHelper<RequestChequeBookState>{

    doAccountNumberChange: BaseFpxChangeHandler = (name: string, status: FormControlStatus, value: any, formGroup: FormGroup) => {
        formGroup.controls['noOfChqBooks'].reset('',{emitEvent : false});
        formGroup.controls['noOfLeaves'].reset('',{emitEvent : false});
        formGroup.controls['dlvryBranch'].reset('',{emitEvent : false});
        formGroup.controls['remarks'].reset('',{emitEvent : false});
    }

    constructor(private requestChequeBookService: RequestChequeBookService,
        private _resultService: ResultService) {
        super(new RequestChequeBookState());
        this.addChangeHandler("accountNumber", this.doAccountNumberChange)
    }

    fetchChequeBookDetails(requestReference, formGroup: FormGroup) {
        this.requestChequeBookService.fetchChequeBookDetails(requestReference).subscribe(
            (res: IRequestChequeBookModel)=> {
                formGroup.patchValue({
                    'accountNumber': res.accountNumber,
                    'dlvryBranch': res.dlvryBranch,
                    'dlvryOption': res.dlvryOption,
                    'noOfChqBooks': res.noOfChqBooks,
                    'noOfLeaves': res.noOfLeaves,
                    'remarks': res.remarks,
                }, { emitEvent: true });
                formGroup.disable({ emitEvent: false });
                this.state.disableMode=true;
            },
            (err)=> {

            }
        );
    }

    public doConfirm(context: any, success: any, failure: any) {
        context = { ...context };
        const payload: any = {};
        payload['chequebookrequest'] = { ...context };
        this.requestChequeBookService.requestChequeBook(payload).subscribe(
            (res) => {
                let additionalFields = {
                    'referenceNumber': res.refNo?res.refNo:res.inventoryNo
                    }
                  this._resultService.setSuccess(
                    res,
                    EAccountServiceCode.REQUEST_CHECK_BOOK,
                    additionalFields
                  );
                success(res);
            },
            (err) => {
                this._resultService.setFailure(
                    err,
                    true,
                );
                failure(err);
            }
        );
    }
    resetState(){
        this.state.disableMode=false;
      }
}